/**
 * What the server says about the phone line (GET /api/v1/dialer).
 *
 * The server answers one question: may this person use the Dialer, and
 * which Amazon Connect instance is it. No call passes through it.
 */
import { api } from '../../services/api';

export interface LineConfig {
  configured: true;
  ccpUrl: string;
  instanceUrl: string;
  region: string;
  callerId: string | null;
  recording: 'OFF' | 'UNSTATED';
}

export type LineAnswer =
  | { kind: 'ready'; line: LineConfig }
  | { kind: 'not-configured' }
  | { kind: 'no-access' }
  | { kind: 'error'; message: string };

export async function getLine(): Promise<LineAnswer> {
  const res = (await api.get('/dialer')) as {
    success: boolean;
    data?: { configured: boolean } & Partial<LineConfig>;
    status?: number;
    error?: string;
  };
  if (res.success && res.data) {
    if (!res.data.configured) return { kind: 'not-configured' };
    return { kind: 'ready', line: res.data as LineConfig };
  }
  if (res.status === 403) return { kind: 'no-access' };
  if (res.status === 401) return { kind: 'error', message: 'Your eMerge session has ended. Sign in again.' };
  return { kind: 'error', message: 'The Dialer could not load. Reload the page to try again.' };
}
